import { CloseContext } from '../components/CassieContainer/websocket/types';

export enum BackdropState {
  None = 0,
  Loading = 1,
  AuthenticationExpired = 2
}

export interface CatoContainerProps {
  instanceURL: string;
  samURL: string;
  region: string;
  onViewContact?: (contactId: string | undefined, closeContext?: CloseContext) => void;
}
